var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Brime Beta APIv2 Inbound"}},[_c('b-card-text',[_vm._v("We will soon release our Beta APIv2. Stay tuned.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }